// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IInvestmentStatusResponse
 */
export interface IInvestmentStatusResponse {
    /**
     * 
     * @type {number}
     * @memberof IInvestmentStatusResponse
     */
    account_id: number;
    /**
     * 
     * @type {number}
     * @memberof IInvestmentStatusResponse
     */
    employee_id: number;
    /**
     * 
     * @type {string}
     * @memberof IInvestmentStatusResponse
     */
    status: IInvestmentStatusResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IInvestmentStatusResponse
     */
    type?: IInvestmentStatusResponseTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof IInvestmentStatusResponse
     */
    risk_tolerance_model?: IInvestmentStatusResponseRiskToleranceModelEnum;
    /**
     * 
     * @type {number}
     * @memberof IInvestmentStatusResponse
     */
    investment_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IInvestmentStatusResponse
     */
    plan_investment_threshold?: number;
    /**
     * 
     * @type {string}
     * @memberof IInvestmentStatusResponse
     */
    auto_invest_scheduling_status?: IInvestmentStatusResponseAutoInvestSchedulingStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IInvestmentStatusResponse
     */
    amount_to_keep?: number;
}

/**
* @export
* @enum {string}
*/
export enum IInvestmentStatusResponseStatusEnum {
    INVESTOR_CREATED = 'INVESTOR_CREATED',
    INVESTMENT_PATH_SELECTED = 'INVESTMENT_PATH_SELECTED',
    QUESTIONNAIRE_FILLED = 'QUESTIONNAIRE_FILLED',
    INVESTMENT_AMOUNT_SELECTED = 'INVESTMENT_AMOUNT_SELECTED',
    PENDING_EXTERNAL_CREATION = 'PENDING_EXTERNAL_CREATION',
    ACTIVE = 'ACTIVE'
}
/**
* @export
* @enum {string}
*/
export enum IInvestmentStatusResponseTypeEnum {
    MANAGED = 'MANAGED',
    BROKERAGE = 'BROKERAGE',
    SELF_DIRECTED = 'SELF_DIRECTED'
}
/**
* @export
* @enum {string}
*/
export enum IInvestmentStatusResponseRiskToleranceModelEnum {
    CONSERVATIVE = 'CONSERVATIVE',
    MODERATELY_CONSERVATIVE = 'MODERATELY_CONSERVATIVE',
    MODERATE = 'MODERATE',
    MODERATELY_AGGRESSIVE = 'MODERATELY_AGGRESSIVE',
    AGGRESSIVE = 'AGGRESSIVE'
}
/**
* @export
* @enum {string}
*/
export enum IInvestmentStatusResponseAutoInvestSchedulingStatusEnum {
    ACTIVE = 'ACTIVE',
    PAUSED = 'PAUSED'
}


/**
 * Check if a given object implements the IInvestmentStatusResponse interface.
 */
export function instanceOfIInvestmentStatusResponse(value: object): value is IInvestmentStatusResponse {
    if (!('account_id' in value) || value['account_id'] === undefined) return false;
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function IInvestmentStatusResponseFromJSON(json: any): IInvestmentStatusResponse {
    return IInvestmentStatusResponseFromJSONTyped(json, false);
}

export function IInvestmentStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvestmentStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'account_id': json['account_id'],
        'employee_id': json['employee_id'],
        'status': json['status'],
        'type': json['type'] == null ? undefined : json['type'],
        'risk_tolerance_model': json['risk_tolerance_model'] == null ? undefined : json['risk_tolerance_model'],
        'investment_balance': json['investment_balance'] == null ? undefined : json['investment_balance'],
        'plan_investment_threshold': json['plan_investment_threshold'] == null ? undefined : json['plan_investment_threshold'],
        'auto_invest_scheduling_status': json['auto_invest_scheduling_status'] == null ? undefined : json['auto_invest_scheduling_status'],
        'amount_to_keep': json['amount_to_keep'] == null ? undefined : json['amount_to_keep'],
    };
}

export function IInvestmentStatusResponseToJSON(json: any): IInvestmentStatusResponse {
    return IInvestmentStatusResponseToJSONTyped(json, false);
}

export function IInvestmentStatusResponseToJSONTyped(value?: IInvestmentStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_id': value['account_id'],
        'employee_id': value['employee_id'],
        'status': value['status'],
        'type': value['type'],
        'risk_tolerance_model': value['risk_tolerance_model'],
        'investment_balance': value['investment_balance'],
        'plan_investment_threshold': value['plan_investment_threshold'],
        'auto_invest_scheduling_status': value['auto_invest_scheduling_status'],
        'amount_to_keep': value['amount_to_keep'],
    };
}

